import React from 'react';

const CombinedStaticDataContext = React.createContext({});

export const CombinedStaticDataProvider = CombinedStaticDataContext.Provider;
export const CombinedStaticDataConsumer = CombinedStaticDataContext.Consumer;

export default CombinedStaticDataContext;
